module.exports = "<div class=\"empty-div\" *ngIf=\"stillLoading\">\n  <p>Fetching Data .... </p>\n  <!-- <div>\n    <img src=\"{{webService.imageUrl}}images/loadingrecord.gif\" style=\"width: 300px;\">\n  </div> -->\n</div>\n\n\n<div class=\"empty-div\" *ngIf=\"!stillLoading&&dataList.length<=0\">\n  <p>{{notFoundMessage}}</p>\n  <p>\n    <i class=\"fa fa-warning\"></i>\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src611197896/src/src/app/generic-ui-components/generic-fetching-records/generic-fetching-records.component.html
// module id = ../../../../../src/app/generic-ui-components/generic-fetching-records/generic-fetching-records.component.html
// module chunks = main